import { useEffect } from 'react';

import { useAuth } from '../../../hooks/useAuth';
import { useNavigate } from '../../../hooks/useNavigate';
import { Card } from '../../common/Card';
import { View } from '../../common/View';

import ForgotPasswordForm from './ForgotPasswordForm';

const ForgotPassword: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    async function run() {
      if (isAuthenticated) {
        navigate('/');
      }
    }
    run();
  }, []);

  return (
    <View
      style={{
        margin: '0 auto',
        justifyContent: 'center',
        width: '100%',
        maxWidth: 400,
      }}
    >
      <Card style={{ padding: 24 }}>
        <h2>Forgot Password</h2>
        <ForgotPasswordForm />
      </Card>
    </View>
  );
};
export default ForgotPassword;
